// src/pages/ScheduleADemo.js
import React from 'react';
import SEO from '../components/SEO';
import DemoRequestForm from '../components/DemoRequestForm';
import FinalCTA from '../components/FinalCTA';

const ScheduleADemo = () => {
  return (
    <>
      <SEO
        title="Schedule a Demo | Oolook"
        description="Book a personalized demo to see how Oolook's AI can supercharge your social strategy, content workflow, and analytics."
      />
      <main className="bg-dark-bg">
        <DemoRequestForm />
        {/* It's good practice to have a final CTA even on a demo page */}
        <FinalCTA /> 
      </main>
    </>
  );
};

export default ScheduleADemo;